import React from 'react';
import AriesButton from './AriesButton';

/**
 * AriesLinkButton — cyan pill. Inherits AriesButton behavior and locks the
 * `link` variant.
 */
const AriesLinkButton = (props) => <AriesButton {...props} variant="link" />;

export default AriesLinkButton;
